import React from 'react';
import bannerImg from '../assets/marketing-banner.png';

const VMiscMarketingDashboard = () => {
	return (
		<a href="https://www.sienna-gestion.com/tous-nos-fonds/sienna-tresorerie-plus" target="_blank" rel="noreferrer">
			<img width="100%" src={bannerImg} style={{ borderRadius: '10px' }} />
		</a>
	);
};

export default VMiscMarketingDashboard;
